import React from 'react';
import { Link } from 'react-router-dom'
import strings from "./../../../components/Language";

import './menu.scss';

import ApiBind from './../../../assets/images/icons/api_bind.webp';
// import ApiBind from './../../../assets/images/icons/api_bind_12.png';
import InviteFriend from './../../../assets/images/icons/invite_friend.webp';
// import InviteFriend from './../../../assets/images/icons/invite_friend_12.png';
import Reward from './../../../assets/images/icons/reward.webp';
// import Reward from './../../../assets/images/icons/reward_12.png';
import Wallet from './../../../assets/images/icons/wallet.webp';
// import Wallet from './../../../assets/images/icons/wallet_12.png';
import AutoTradeIcon from './../../../assets/images/icons/autoTradeIcon.svg';
import AutoTradeWhiteIcon from './../../../assets/images/icons/autoTradeIconWhite.svg';

import { toast } from 'react-toastify';
import { getToken, storeUserData, getUserData } from './../../../components/Util';
import axios from 'axios';
import { api } from '../../../components/config/api';
class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            access_token: "",
            user_data: {},
            isStart: false
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            setTimeout(() => {
                this.setState({ access_token: token });
                var user_data = getUserData();
                if (user_data && user_data.data) {
                    this.setState({ user_data: user_data });
                }
                this.getData();
            });
        }
    }

    getData() {
        var self = this;
        if (self.state.access_token) {
            axios({
                method: 'GET',
                url: api.auto_trade,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                console.log("ress.data:::", ress.data);

                if (ress.data && ress.data.error === 200) {
                    self.setState({
                        isStart: ress.data.data.status,
                    });
                }
                self.setState({ is_load: false });
            }).catch(function (e) {
                self.setState({ is_load: false });
            });
        }
    };

    render() {

        return (
            <div className="menu_card">
                <div className="row">
                    <Link to="/apibind" className="width-20 text-center" style={{ width: "20%" }}>
                        <img className="image_icon" style={{ width: 40, height: 40 }} src={ApiBind} alt="ApiBind" />
                        <div className="text_icon">{strings.api_bind}</div>
                    </Link>
                    {(this.state.user_data && this.state.user_data.status) ?
                        <Link to="/invite-link" className="width-20 text-center" style={{ width: "20%" }}>
                            <img className="image_icon" style={{ width: 40, height: 40 }} src={InviteFriend} alt="Invite" />
                            <div className="text_icon">{strings.share}</div>
                        </Link>
                        :
                        <div onClick={() => toast.warning(strings.need_to_active_account)} className="width-20 text-center" style={{ width: "20%", cursor: "pointer" }}>
                            <img className="image_icon" style={{ width: 40, height: 40 }} src={InviteFriend} alt="Invite" />
                            <div className="text_icon">{strings.share}</div>
                        </div>
                    }
                    <Link to="/wallet" className="width-20 text-center" style={{ width: "20%" }}>
                        <img className="image_icon" style={{ width: 40, height: 40 }} src={Wallet} alt="Wallet" />
                        <div className="text_icon">{strings.wallet}</div>
                    </Link>
                    <Link to="/auto-trade" className="width-20 text-center" style={{ width: "20%" }}>
                        <div className={`${this.state.isStart ? 'menu_active' : ''}`}>
                            {this.state.isStart ?
                                <img className="image_icon" style={{ width: 40, height: 40 }} src={AutoTradeWhiteIcon} alt="Wallet" />
                                :
                                <img className="image_icon" style={{ width: 40, height: 40 }} src={AutoTradeIcon} alt="Wallet" />
                            }
                            <div className="text_icon">{strings.AutoTrade}</div>
                        </div>
                    </Link>
                    <Link to="/reward" className="width-20 text-center" style={{ width: "20%" }}>
                        <img className="image_icon" style={{ width: 40, height: 40 }} src={Reward} alt="Reward" />
                        <div className="text_icon">{strings.rewards}</div>
                    </Link>
                </div>
            </div>
        );
    };
}

export default Menu;
